import { render } from "./Dispatch.vue?vue&type=template&id=9bfd8506&scoped=true"
import script from "./Dispatch.vue?vue&type=script&lang=js"
export * from "./Dispatch.vue?vue&type=script&lang=js"

import "./Dispatch.vue?vue&type=style&index=0&id=9bfd8506&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bfd8506"]])

export default __exports__